import debounce from 'lodash.debounce';

interface VisualViewport extends EventTarget {
  width: number;
  height: number;
  scale: number;
  offsetLeft: number;
  offsetTop: number;
  pageLeft: number;
  pageTop: number;
  addEventListener(
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions
  ): void;
  removeEventListener(
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | EventListenerOptions
  ): void;
}

export type WindowWithVisualViewport = Window & {
  visualViewport?: VisualViewport;
};

type ReturnType = {
  addListener: () => void;
  removeListener: () => void;
};

export const listenForViewportChange = (callback: () => void): ReturnType => {
  const win = window as WindowWithVisualViewport;
  const viewport = win.visualViewport ?? window;
  const getBoundsDebounced = debounce(callback, 200);

  const addListener = (): void => {
    viewport.addEventListener('resize', getBoundsDebounced);
  };

  const removeListener = (): void => {
    viewport.removeEventListener('resize', getBoundsDebounced);
  };

  return {
    addListener,
    removeListener,
  };
};
